/**
 * The language toggle. On every screen, in the masthead, always visible.
 *
 * Both labels are written in their own language, because a reader looking for
 * Malayalam should not have to read English to find it.
 */

import { useLang } from "@ksidc/client";

export function LangToggle(): JSX.Element {
  const { lang, setLang } = useLang();
  return (
    <div
      className="toggle-group no-print"
      role="group"
      aria-label="Language / ഭാഷ"
    >
      <button
        type="button"
        lang="en"
        aria-pressed={lang === "en"}
        onClick={() => setLang("en")}
      >
        English
      </button>
      <button
        type="button"
        lang="ml"
        aria-pressed={lang === "ml"}
        onClick={() => setLang("ml")}
      >
        മലയാളം
      </button>
    </div>
  );
}
